import { render, staticRenderFns } from "./policyService.vue?vue&type=template&id=c5bb243e&scoped=true"
import script from "./policyService.vue?vue&type=script&lang=js"
export * from "./policyService.vue?vue&type=script&lang=js"
import style0 from "./policyService.vue?vue&type=style&index=0&id=c5bb243e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5bb243e",
  null
  
)

export default component.exports